var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThinkabout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_553",
    "data-name": "Raggruppa 553",
    transform: "translate(-1660 -199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_support-24px_1_",
    "data-name": "contact_support-24px (1)",
    transform: "translate(1660 199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_700",
    "data-name": "Tracciato 700",
    d: "M11.5,3a7.5,7.5,0,0,0,0,15H13v2.3c3.64-2.3,6-6.08,6-9.8A7.5,7.5,0,0,0,11.5,3Zm-1,11.5h2v2h-2Z",
    fill: "#ffc8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_665",
    "data-name": "Tracciato 665",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "contact_support-24px_1_2",
    "data-name": "contact_support-24px (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_665-2",
    "data-name": "Tracciato 665",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_666",
    "data-name": "Tracciato 666",
    d: "M11,23.59v-3.6A9.5,9.5,0,1,1,21,10.5c0,4.95-3.44,9.93-8.57,12.4ZM11.5,3a7.5,7.5,0,0,0,0,15H13v2.3c3.64-2.3,6-6.08,6-9.8A7.5,7.5,0,0,0,11.5,3Zm-1,11.5h2v2h-2Zm2-1.5h-2c0-3.25,3-3,3-5a2,2,0,0,0-4,0h-2a4,4,0,0,1,8,0C15.5,10.5,12.5,10.75,12.5,13Z",
    fill: "#ff7261"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkabout);
export default __webpack_public_path__ + "static/media/thinkabout.9cada8bca4afbb5a38ca208fb5ac441f.svg";
export { ForwardRef as ReactComponent };